import React, { useEffect, useRef, useState } from "react";
import { Box, FormControl, FormControlLabel, FormGroup, Grid, Paper, Stack, Switch, TextField, Typography } from "@mui/material";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import { useHistory } from "react-router-dom";
import RichTextEditor from "../../components/reusableComponents/richTextEditior";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import ApiService from "../../_services/ApiService";
import { regexValidator } from "../../_helpers/reusablefunctions/regexValidator";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import ReusableMultiComponent from "../../components/reusableComponents/ReusableMultiComponent";
import { useSelector } from "react-redux";
import ReusableCheckboxGroup from "../../components/reusableComponents/reusableCheckboxGroup ";
import { matchChoiceValue, SCHEDULE_CHOICES, STIPEND_CHOICES, TYPESEMPLOYMENT_CHOICES, TYPESWORKPLACE_CHOICES } from "./listJsonInternship";
import ReusableRadioGroup from "../../components/reusableComponents/reusableRadioGroup ";
import { eligibleRequirement, featuredRequirement } from "../../_helpers/reusablefunctions/eligibleRequirement";
import ReusableImageComponent from "../../components/reusableComponents/ReusableImageComponent";
import FirebaseImageStore from "../../_helpers/reusablefunctions/firebaseImageStore";
import { validateImageFile } from "../../_helpers/reusablefunctions/validateImageFile";
import { useParams, useLocation } from "react-router-dom";
import ReusableDateInput from "../../components/reusableComponents/ReusableDateInput";
import { useLiveFieldErrors } from "../../hooks/useLiveFieldErrors";
import { scrollToFirstError } from "../../_helpers/reusablefunctions/scrollToFirstError";
import { hasAnyValue } from "../../_helpers/reusablefunctions/formHasData";
import ConfirmationDialog from "../../components/reusableComponents/conformationDialogBox";
import dayjs from "dayjs";

const marginBottom = "20px";

export default function CreateInternshipManagement(params) {
    const { successSnack, errorSnack } = useSnackDispatcher();
    const history = useHistory();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData;
    const userData = useSelector((state) => state.userData.userData);
    const [Title, setTitle] = useState("");
    const [SocialLink, setSocialLink] = useState("");
    const [JobLocation, setJobLocation] = useState("");
    const [TotalOpening, setTotalOpening] = useState("");
    const [TotalExperience, setTotalExperience] = useState("");
    const [InternshipList, setInternshipList] = useState([]);
    const [InternshipListSelection, setInternshipListSelection] = useState([]);
    const [SkillsList, setSkillsList] = useState([]);
    const [SkillsListSelection, setSkillsListeSelection] = useState([]);
    const [BenefitsList, setBenefitsList] = useState([]);
    const [BenefitsListSelection, setBenefitsListSelection] = useState([]);
    const [StipendAmount, setStipendAmount] = useState("");
    const [Stipend, setStipend] = useState("");
    const [Is_Negotiable, setIs_Negotiable] = useState("");
    const [WorkingSchedule, setWorkingSchedule] = useState('');
    const [TypesEmployment, setTypesEmployment] = useState('');
    const requirement = eligibleRequirement();
    const featureList = featuredRequirement();

    const [eligibleRequirementSelection, setEligibleRequirementSelection] = useState([]);
    const [TypesWorkplace, setTypesWorkplace] = useState("");
    const [FAQ, setFAQ] = useState("");
    const [JobDescription, setJobDescription] = useState("");
    const [DeadLineDate, setDeadLineDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [confirmLeaveOpen, setConfirmLeaveOpen] = useState(false);
    const lastValidatedDraft = useRef(null); // null until the first submit attempt
    const [loader, setLoader] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [internshipImageURL, setInternshipImageURL] = useState(null);
    const [eligibleFeaturedSelection, setEligibleFeaturedSelection] = useState([]);
    const [isDraft, setIsDraft] = useState(null);
    const [Course_Duration, setCourse_Duration] = useState("");

    const { uploadImages } = FirebaseImageStore({
        selectedFile,
        selectedFiles: [], // no extra images for internship, keep empty
        functionCall: ({ bannerURL }, draft) =>
            submitOfferDetails({ downloadURL: bannerURL, draft }),
    });


    // ---------------- edit internship start ---------------
    const { id } = useParams(); // if present, it's edit mode
    const isEditMode = Boolean(id);
    useEffect(() => {
        if (isEditMode && locationEventDetail) {
            const data = locationEventDetail;

            // Set basic fields
            setInternshipImageURL(data?.Featured_Banner_URL || data?.Featured_Banner || null);
            setTitle(data?.Title || "");
            setSocialLink(data?.SocialLink || "");
            setJobLocation(data?.JobLocation || "");
            setTotalOpening(data?.TotalOpening != null ? String(data.TotalOpening) : "");
            setTotalExperience(data?.TotalExperience != null ? String(data.TotalExperience) : "");
            setStipendAmount(data?.StipendAmount != null ? String(data.StipendAmount) : "");
            setStipend(data?.Stipend || "");
            setIs_Negotiable(data?.Is_Negotiable === true || data?.Is_Negotiable === 'yes');
            setWorkingSchedule(matchChoiceValue(SCHEDULE_CHOICES, data?.WorkingSchedule));
            setTypesWorkplace(matchChoiceValue(TYPESWORKPLACE_CHOICES, data?.TypesWorkplace) || "remote");
            setTypesEmployment(matchChoiceValue(TYPESEMPLOYMENT_CHOICES, data?.TypesEmployment));
            setDeadLineDate(data?.DeadLineDate || "");
            setJobDescription(data?.JobDescription || "");
            setFAQ(data?.FAQ || "");
            setCourse_Duration(data?.Course_Duration != null ? String(data.Course_Duration) : "");
            setEligibleFeaturedSelection(
                featureList.filter((item) => data[item?.Value])
            );
            // Internship list matching by ID
            if (Array.isArray(data?.InternshipList) && InternshipListSelection.length) {
                const matchedInternships = InternshipListSelection.filter(item =>
                    data?.InternshipList.includes(item.id)
                );
                setInternshipList(matchedInternships);
            }

            // Skills list matching by ID
            if (Array.isArray(data?.SkillsList) && SkillsListSelection.length) {
                const matchedSkills = SkillsListSelection.filter(item =>
                    data?.SkillsList.includes(item.id)
                );
                setSkillsList(matchedSkills);
            }

            // Benefits list matching by ID
            if (Array.isArray(data?.BenefitsList) && BenefitsListSelection.length) {
                const matchedBenefits = BenefitsListSelection.filter(item =>
                    data?.BenefitsList.includes(item.id)
                );
                setBenefitsList(matchedBenefits);
            }

            // Eligible requirements
            setEligibleRequirementSelection(
                requirement.filter((item) => data[item?.Value])
            );
        }
    }, [isEditMode, locationEventDetail, InternshipListSelection, SkillsListSelection, BenefitsListSelection]);

    // ---------------- edit internship end ---------------

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            validateImageFile(file, 382, 185, (errorMsg) => {
                if (errorMsg) {
                    setErrors(prev => ({ ...prev, image: errorMsg }));
                    setSelectedFile(null);
                } else {
                    setSelectedFile(file);
                    setErrors(prev => ({ ...prev, image: null }));
                }
            });
        }
    };


    const handleWorkModeChange = (event, option) => {
        setTypesWorkplace(event.target.value);
    };

    // Change handler for stipend
    const handleStipendChange = (event, option) => {
        setStipend(event.target.value);
    };

    const handlWorkingScheduleChange = (event, option) => {
        setWorkingSchedule(event.target.value);
    };

    // Change handler for stipend
    const handleTypesEmploymentChange = (event, option) => {
        setTypesEmployment(event.target.value);
    };

    useEffect(() => {
        ApiService.get('intershipType').then((res) => {
            if (res?.status == 200 || res?.status == 201) {
                setInternshipListSelection(res?.data?.data)
            }
        }).catch(error => {
            console.log("event:", error)
        })

        // --------------intershipSkills-------------

        ApiService.get('intershipSkills').then((res) => {
            if (res?.status == 200 || res?.status == 201) {
                setSkillsListeSelection(res?.data?.data)
            }
        }).catch(error => {
            console.log("event:", error)
        })

        // -----------------------

        ApiService.get('intershipBenefit').then((res) => {
            if (res?.status == 200 || res?.status == 201) {
                setBenefitsListSelection(res?.data?.data)
            }
        }).catch(error => {
            console.log("event:", error)
        })
    }, [])

    // --------------- validation handler ----------

    // values coming back from the API can be numbers, so never call .trim() directly
    const isBlank = (value) => String(value ?? '').trim() === '';

    function computeValidation(draft) {
        let errors = {};
        let isValid = true;

        if (isBlank(Title)) {
            errors.Title = "Internship title is required.";
            isValid = false;
        }
        if (isBlank(JobLocation)) {
            errors.JobLocation = "Job location is required.";
            isValid = false;
        }
        if (isBlank(TotalOpening)) {
            errors.TotalOpening = "Total Opening is required.";
            isValid = false;
        }
        if (isBlank(JobDescription)) {
            errors.JobDescription = "Job description is required.";
            isValid = false;
        }
        if (isBlank(Course_Duration)) {
            errors.Course_Duration = "Internship duration is required.";
            isValid = false;
        }
        if (!draft) {
            // if (SocialLink.trim() === '' || !regexValidator(SocialLink, 'URL')) {
            //     errors.SocialLink = "Social link is required";
            //     isValid = false;
            // }
            // the API rejects a publish without Featured_Banner_URL, so catch it
            // here instead of letting the user find out through a 400
            if (!selectedFile && !internshipImageURL) {
                errors.image = "Please upload the banner.";
                isValid = false;
            }
            if (!eligibleRequirementSelection.length) {
                errors.eligibleRequirementSelection = "Check atleast one.";
                isValid = false;
            }
            if (Stipend === '') {
                errors.Stipend = "Select Stipend.";
                isValid = false;
            }
            if (!InternshipList.length) {
                errors.InternshipList = "Select department.";
                isValid = false;
            }
            if (!SkillsList.length) {
                errors.SkillsList = "Select skills.";
                isValid = false;
            }
            if (!BenefitsList.length) {
                errors.BenefitsList = "Select benefits.";
                isValid = false;
            }
            if (!WorkingSchedule) {
                errors.WorkingSchedule = "Select work schedule.";
                isValid = false;
            }
            if (!TypesEmployment) {
                errors.TypesEmployment = "Select employment type.";
                isValid = false;
            }
            if (!TypesWorkplace) {
                errors.TypesWorkplace = "Select work place type.";
                isValid = false;
            }
            if (!DeadLineDate) {
                errors.DeadLineDate = "Select deadline.";
                isValid = false;
            }
        }

        return { errors, isValid };
    }

    function validationInputs(draft) {
        lastValidatedDraft.current = draft;
        const { errors, isValid } = computeValidation(draft);
        setErrors(errors); // Store errors in state
        return isValid;
    }

    // after the first submit attempt, keep each field's error in sync with its value
    useLiveFieldErrors({
        setErrors,
        computeErrors: () =>
            lastValidatedDraft.current === null
                ? null
                : computeValidation(lastValidatedDraft.current).errors,
        managedKeys: [
            'Title', 'JobLocation', 'TotalOpening', 'JobDescription', 'Course_Duration',
            'eligibleRequirementSelection', 'Stipend', 'InternshipList', 'SkillsList',
            'BenefitsList', 'WorkingSchedule', 'TypesEmployment', 'TypesWorkplace', 'DeadLineDate',
        ],
        deps: [
            Title, JobLocation, TotalOpening, JobDescription, Course_Duration,
            eligibleRequirementSelection, Stipend, InternshipList, SkillsList,
            BenefitsList, WorkingSchedule, TypesEmployment, TypesWorkplace, DeadLineDate,
        ],
    });

    // ------------- submit handler ---------

    const handleResponse = (res, draft) => {
        if (res.status === 200 || res.status === 201) {
            setLoader(false);
            successSnack(draft ? formSnackbar?.profileSuccess?.successMessageDraft : formSnackbar?.profileSuccess?.successMessage)
            if (draft) {
                history.push('/Internship/view-internship-draft');
            } else {
                history.push('/Internship');
            }
        } else {
            const body = res?.data || {};
            // the API answers a rejected save as { status, errors: { field: [...] } },
            // so unwrap that envelope — otherwise the snackbar reads back raw JSON
            const errorData =
                body?.errors && typeof body.errors === "object" ? body.errors : body;
            Object.keys(errorData).forEach(field => {
                let messages = errorData[field];

                if (Array.isArray(messages)) {
                    messages = messages.join(', ');
                } else if (typeof messages === "object" && messages !== null) {
                    messages = JSON.stringify(messages);
                }

                errorSnack(`${field}: ${messages}`);
            });
        }
    };

    const handleError = (error) => {
        setLoader(false);
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
    };

    function submitProfile(e, draft) {
        e.preventDefault();

        // without a brand id the record saves with BrandID null and never shows
        // up in any brand-filtered list, so block the save instead
        if (!userData?.brand) {
            errorSnack("Brand details are still loading. Please refresh and try again.");
            return;
        }

        const isValid = validationInputs(draft);
        if (!isValid) {
            scrollToFirstError();
            return;
        }

        if (!selectedFile) {
            // no new banner – use existing internshipImageURL (if any)
            submitOfferDetails({ downloadURL: internshipImageURL, draft });
        } else {
            // upload new banner then submit
            uploadImages(draft);
        }
    }


    function submitOfferDetails({ downloadURL, draft }) {

        const benefitsList = BenefitsList.map(type => type.id)

        const internshipList = InternshipList.map(type => type.id)
        const skillsList = SkillsList.map(type => type.id)

        let payload = {
            "Title": Title,
            "SocialLink": SocialLink,
            "InternshipList": internshipList,
            "JobLocation": JobLocation,
            "TotalOpening": TotalOpening,
            "TotalExperience": TotalExperience,
            "Stipend": Stipend,
            "StipendAmount": StipendAmount,
            "Is_Negotiable": Is_Negotiable ? 'yes' : 'no',
            "WorkingSchedule": WorkingSchedule,
            "TypesEmployment": TypesEmployment,
            "TypesWorkplace": TypesWorkplace,
            "DeadLineDate": DeadLineDate ? dayjs(DeadLineDate).format('YYYY-MM-DD') : null,
            "SkillsList": skillsList,
            "BenefitsList": benefitsList,
            "JobDescription": JobDescription,
            "FAQ": FAQ,
            'BrandID': userData?.brand,
            ...eligibleFeaturedSelection
                .filter(delivey => delivey?.Value)
                .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            ...eligibleRequirementSelection
                .filter(delivey => delivey?.Value)
                .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            'BrandLogoURL': userData?.avatar_url,
            'BrandName': userData?.brand_name,
            'Featured_Banner_URL': downloadURL,
            'Is_draft': draft,
            'Enable_Brand': true,
            "Course_Duration": Course_Duration,
        }
        console.debug("createinternship: DeadLineDate", payload)
        setIsDraft(draft);
        setLoader(true);
        const request = isEditMode
            ? ApiService.put('internship_updation', payload, {}, id)
            : ApiService.post('Internshipscreate', payload);

        request
            .then(res => handleResponse(res, draft))
            .catch(handleError)
            .finally(() => setLoader(false));
    }

    const hasFormData = () => hasAnyValue([
        Title, SocialLink, JobLocation, TotalOpening, TotalExperience, Course_Duration,
        StipendAmount, Stipend, Is_Negotiable, WorkingSchedule, TypesEmployment, TypesWorkplace,
        FAQ, JobDescription, DeadLineDate, InternshipList, SkillsList, BenefitsList,
        eligibleRequirementSelection, eligibleFeaturedSelection, selectedFile,
    ]);

    function backClickHistory(params) {
        if (hasFormData()) {
            setConfirmLeaveOpen(true);
            return;
        }
        history.push('/Internship')
    }

    const leaveWithoutSaving = () => {
        setConfirmLeaveOpen(false);
        history.push('/Internship');
    };

    const ButtonComponentInternship = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ReusableButton loader={isDraft && loader} disabled={isDraft != null ? !isDraft : false} variant="outlined" classNames={'gn-actionbtn-outline gn-actionbtn-color '}
                    onClick={(e) => submitProfile(e, true)}
                    children="Save Draft" sx={{ color: '#6D788D', marginRight: '10px' }} />
                <ReusableButton loader={!isDraft && loader} disabled={isDraft} classNames={'gn-actionbtn'}
                    variant="outlined" children="Publish internship"
                    sx={{ color: '#6D788D' }}
                    onClick={(e) => submitProfile(e, false)} />
            </Box>
        )
    }
    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={{ xs: 'none', sm: 'center', md: 'center' }} justifyContent={'space-between'} sx={{ flexDirection: { xs: 'column', sm: 'row', md: 'row' }, paddingBottom: { xs: '20px', sm: 0, md: 0 } }} >
                <ReusableHeadingComponents bacHistory={true} clickHandlerBack={backClickHistory} heading={'Internship Application Form'} subHeading={''} />
                {ButtonComponentInternship()}
            </Box>
            <Grid container spacing={2} >
                <Grid item xs={12} md={12}>
                    <ReusableCardView title="Upload Banner" required={true} Component={
                        <Box>
                            <ReusableImageComponent
                                selectedFile={selectedFile}
                                handleFileChange={handleImageChange}
                                disabled={false}
                                imageSrc={internshipImageURL} // Or provide a URL if editing existing image
                                tooltipTitle="Change Cover Image"
                                imageBannerRatioText='The Offer image must be 382x185 pixels.'
                                error={!!errors.image}
                                helperText={errors.image}
                                selectedOptions={eligibleFeaturedSelection}
                                setSelectedOptions={setEligibleFeaturedSelection}
                            />
                        </Box>
                    } />
                </Grid>
                {/* Left Section */}
                <Grid item xs={12} md={6}>
                    <ReusableCardView title="Basic" Component={
                        <Box px={2} pt={3} pb={3}>
                            <ReusableComponent
                                type="text"
                                label="Internship title"
                                value={Title}
                                onChange={setTitle}
                                error={!!errors.Title}
                                helperText={errors.Title}
                                placeholder={'Internship title'}
                                marginSize={marginBottom}
                                requireValue={true}
                                required />

                            <ReusableComponent
                                type="text"
                                label="Social links"
                                value={SocialLink}
                                onChange={setSocialLink}
                                error={!!errors.SocialLink}
                                helperText={errors.SocialLink}
                                placeholder="Social link"
                            />
                        </Box>
                    } />

                    <ReusableCardView title="Internship criteria  " Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <ReusableComponent
                                type="text"
                                label="Job location"
                                value={JobLocation}
                                onChange={setJobLocation}
                                error={!!errors.JobLocation}
                                helperText={errors.JobLocation}
                                requireValue={true}
                                placeholder={'Job location'}
                                marginSize={marginBottom} />

                            <ReusableComponent
                                type="numeric"
                                label="No. of opening"
                                value={TotalOpening}
                                onChange={setTotalOpening}
                                error={!!errors.TotalOpening}
                                helperText={errors.TotalOpening}
                                placeholder={'Total opening'}
                                requireValue={true}
                                marginSize={marginBottom} />

                            <ReusableComponent
                                type="text"
                                label="Experience"
                                value={TotalExperience}
                                onChange={setTotalExperience}
                                error={!!errors.TotalExperience}
                                helperText={errors.TotalExperience}
                                placeholder="Experience"
                                marginSize={marginBottom}
                            />

                            <ReusableComponent
                                type="numeric"
                                label="Internship duration (months)"
                                requireValue={true}
                                value={Course_Duration}
                                onChange={setCourse_Duration}
                                error={!!errors.Course_Duration}
                                helperText={errors.Course_Duration}
                                placeholder="e.g., 4 or 6 months"
                                marginSize={marginBottom}
                            />


                            <ReusableRadioGroup
                                label="Working schedule"
                                requireValue={true}
                                options={SCHEDULE_CHOICES}
                                value={WorkingSchedule}
                                onChange={handlWorkingScheduleChange}
                                // optionLabel="Name"
                                error={!!errors.WorkingSchedule}
                                helperText={errors.WorkingSchedule}
                            />

                            <ReusableRadioGroup
                                label="Employment type"
                                requireValue={true}
                                options={TYPESEMPLOYMENT_CHOICES}
                                value={TypesEmployment}
                                onChange={handleTypesEmploymentChange}
                                // optionLabel="Name"
                                error={!!errors.TypesEmployment}
                                helperText={errors.TypesEmployment}
                            />

                            <ReusableDateInput
                                valueInput="Deadline date"
                                required={true}
                                DeadLineDate={DeadLineDate}
                                setDeadLineDate={setDeadLineDate}
                                error={!!errors.DeadLineDate}
                                helperText={errors.DeadLineDate}
                            />

                        </Box>
                    } />
                </Grid>

                {/* Right Section */}
                <Grid item xs={12} md={6}>
                    <ReusableCardView title="Department " Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <ReusableMultiComponent label={'Category'}
                                options={InternshipListSelection}
                                selectedOptions={InternshipList}
                                setSelectedOptions={setInternshipList}
                                optionLabel="TypeName"
                                requireValue={true}
                                error={!!errors.InternshipList}
                                helperText={errors.InternshipList}
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    <ReusableCardView title="Add skills " Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <ReusableMultiComponent label={'Key skills'}
                            requireValue={true}
                                options={SkillsListSelection}
                                selectedOptions={SkillsList}
                                setSelectedOptions={setSkillsList}
                                optionLabel="Name"
                                error={!!errors.SkillsList}
                                helperText={errors.SkillsList}
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    <ReusableCardView title="Benefits " Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <ReusableMultiComponent label={'Benefits'}
                            requireValue={true}
                                options={BenefitsListSelection}
                                selectedOptions={BenefitsList}
                                setSelectedOptions={setBenefitsList}
                                optionLabel="Name"
                                error={!!errors.BenefitsList}
                                helperText={errors.BenefitsList}
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    <ReusableCardView title="Stipend " Component={
                        <Box px={2} pt={1} pb={3}>
                            <ReusableRadioGroup
                                label=""
                                requireValue={true}
                                options={STIPEND_CHOICES}
                                value={Stipend}
                                onChange={handleStipendChange}
                                error={!!errors.Stipend}
                                helperText={errors.Stipend}
                            />

                            <ReusableComponent type="numeric"
                                label="Amount"
                                value={StipendAmount}
                                onChange={setStipendAmount}
                                error={!!errors.StipendAmount}
                                helperText={errors.StipendAmount}
                                placeholder={'e.g.,1000'}
                                disabledValue={Stipend == "unpaid" ? true : false} />

                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch checked={Is_Negotiable} onChange={(e) => setIs_Negotiable(e.target.checked)} name="Salary is negotiable" />
                                    }
                                    label="Salary is negotiable"
                                />
                            </FormGroup>
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    <ReusableCardView title="Work mode " Component={
                        <Box px={2} pt={1} pb={2}>
                            <ReusableRadioGroup
                                label=""
                                requireValue={true}
                                options={TYPESWORKPLACE_CHOICES}
                                value={TypesWorkplace}
                                onChange={handleWorkModeChange}
                                error={!!errors.TypesWorkplace}
                                helperText={errors.TypesWorkplace}
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    {/* --------------- featured and home featured ------------ */}
                    {/* <ReusableCardView title="Request Banner Placement" Component={
                        <Box px={3}>
                            <ReusableCheckboxGroup
                                title=""
                                options={featureList}
                                selectedOptions={eligibleFeaturedSelection}
                                setSelectedOptions={setEligibleFeaturedSelection}
                                optionLabel="Name"
                                selectAllLabel="featured"
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} /> */}

                </Grid>
                <Grid item xs={12} md={12}>

                    <ReusableCardView title="Eligibility & Targeting" Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <ReusableCheckboxGroup
                                title="Requirements"
                                requireValue={true}
                                options={[{
                                    "id": 1,
                                    "Name": "Youth",
                                    "Value": 'Enable_Student'
                                }]}
                                selectedOptions={eligibleRequirementSelection}
                                setSelectedOptions={setEligibleRequirementSelection}
                                optionLabel="Name"
                                selectAllLabel="All Users"
                                error={!!errors.eligibleRequirementSelection}
                                helperText={errors.eligibleRequirementSelection}
                            />
                            {/* <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#4C4E64', fontSize: '14px', marginBottom: 2 }}>
                                Redemption Instructions
                            </Typography>
                            <RichTextEditor
                                value={Howtoredeem}
                                onChange={setHowtoredeem}
                                placeholder="Write something..."
                            /> */}


                        </Box>
                    }
                        disablepaddingBottom={true} />
                </Grid>

                {/* ---------------------Job Description--------------- */}
                <Grid item xs={12} md={12}>
                    <ReusableCardView title={<>Job description <span style={{ color: '#d32f2f' }}>*</span></>} Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <RichTextEditor
                                value={JobDescription}
                                onChange={setJobDescription}
                                placeholder="Write something..."
                                error={!!errors.JobDescription}
                                helperText={errors.JobDescription}
                            />
                        </Box>
                    } />
                </Grid>

                {/* ----------------- FAQ ------------------ */}
                <Grid item xs={12} md={12}>
                    <ReusableCardView title="FAQ" Component={
                        <Box px={2} pt={3} pb={3}>
                            {/* <Box p={3}> */}
                            <RichTextEditor
                                value={FAQ}
                                onChange={setFAQ}
                                placeholder="Write something..."
                            />
                        </Box>
                    } />
                </Grid>
            </Grid>
            <Box sx={{ marginBottom: '30px' }}>{ButtonComponentInternship()}</Box>

            <ConfirmationDialog
                open={confirmLeaveOpen}
                title="Leave without saving?"
                message="You have unsaved details in this internship. If you leave now, they will be lost."
                onClose={() => setConfirmLeaveOpen(false)}
                onConfirm={leaveWithoutSaving}
            />
        </Box>
    )

}